import { connect } from 'react-redux';
import ResetPassword from './ResetPassword';
import { 
    resetPasswordRequest,
    resetErrorMesage,
    resetLoginActionsRequest 
} from '../../../store/actions/auth.actions';

import {
    resetPasswordResponse as resetPasswordResponseData,
    loginInProgress,
    passwordResetRequired,
    passwordResetToken as passwordResetTokenData
} from '../../../store/selectors/auth.selector';

const mapDispatchToProps = { updatePasswordRequest: resetPasswordRequest, resetErrorMesage, resetLoginActionsRequest };

const mapStateToProps = (state) => {
    const resetPasswordResponse = resetPasswordResponseData(state);
    const isPasswordResetRequired = passwordResetRequired(state);
    const passwordResetToken = passwordResetTokenData(state);
    const isLoading = loginInProgress(state);
    return { resetPasswordResponse, isLoading, isPasswordResetRequired, passwordResetToken };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);